import { Component, NgModule, IterableDiffers, DoCheck } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { ExpandableListModule } from 'angular2-expandable-list'
import { RestApiServices } from '../providers/rest.service';
import { SharedServiceService } from '../shared/shared-service.service';
import { LanguageService } from '../providers/lang.service';
import { CartitemsService } from '../providers/cartitems.service';

@Component({
    selector: 'filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.css'],

})
export class FilterComponent {

    filterDetails = [];
    showHide = false;
    listAExpanded = false;
    listBExpanded = true;
    listCExpanded = false;
    differ: any;
    selectedFilters = [];
    categoryFilters = [];
    txt_vendor: string = ""; txt_make: string = ""; txt_fabric: string = ""; txt_family: string = "";
    txt_filter: string = ""; txt_filterby: string = ""; txt_clearall: string = ""; 
    constructor(private restApi: RestApiServices, differs: IterableDiffers, private langService: LanguageService,
        private sharedService: SharedServiceService, private cartitems: CartitemsService) {
        //this.differ = differs.find([]).create(null);
    }
    changeShowStatus() {
        this.showHide = !this.showHide;
    }
    ngOnInit() {
        this.langService.getJson().subscribe(data => {
            this.setLabels();
            //  this.restApi.getFilterData().subscribe(result => {
            //    this.filterDetails = result.json().response.data.categories;
            //  });
            this.restApi.selectedCategoryItem.subscribe(category => {
                //this.changeShowStatus();
                this.categoryFilters = category.filter;
                //this.filterDetails = category.filter;
                this.convertJson(this.categoryFilters);
                this.filters = {};


            });
        });
    }


    convertJson(data) {
        let filters = [];
        for (let filter in data) {

            let keys = [];
            if (filter != "fabric"){
                for (let item in data[filter]) {
                    keys.push({ key: data[filter][item], selected: false });
                }
                filters.push({ key: filter, filterValues: keys });
            }
            

            
        }
        
        this.filterDetails = filters;
        console.log(this.filterDetails);
    }

    clearAll() {
        this.filters = {};
        this.convertJson(this.categoryFilters);
        this.sharedService.setFiltersData('');
    }


    filters: any = {};

    processChange(filter, subfilter, selected) {


        if (selected) {
            if (this.filters[filter] != undefined)
                this.filters[filter].push(subfilter);
            else
                this.filters[filter] = [subfilter];
        }
        else if (this.filters[filter] != undefined) {
            var index = this.filters[filter].indexOf(subfilter);
            if (index != -1) {
                this.filters[filter].splice(index, 1);
                if (this.filters[filter].length === 0) {
                    delete this.filters[filter];
                }
            }
        }
        this.sharedService.setFiltersData(this.filters);
    }
    setLabels() {
        this.langService.getLangLabelValue("LblVendor").then(result => {
            this.txt_vendor = result;
        });
        this.langService.getLangLabelValue("LblMake").then(result => {
            this.txt_make = result;
        });
        this.langService.getLangLabelValue("LblFamily").then(result => {
            this.txt_family = result;
        });
        this.langService.getLangLabelValue("LblFabric").then(result => {
            this.txt_fabric = result;
        });
        this.langService.getLangLabelValue("LblFilter").then(result => {
            this.txt_filter = result;
        });
        this.langService.getLangLabelValue("LblFilterBy").then(result => {
            this.txt_filterby = result;
        });
        this.langService.getLangLabelValue("LblClearAll").then(result => {
            this.txt_clearall = result;
        });
    }
    getfilterlabels(key: string) {
        key = key.toLowerCase()
        switch (key) {
            case "vendor":
                return this.txt_vendor;
            case "family":
                return this.txt_family;
            case "fabric":
                return this.txt_fabric;
            case "make":
                return this.txt_make;
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/filter/filter.component.ts